import { render, staticRenderFns } from "./OT.vue?vue&type=template&id=bb698916&"
import script from "./OT.vue?vue&type=script&lang=js&"
export * from "./OT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports